module.exports = __webpack_public_path__ + "img/defaultVoucherIco.498249df.png";